
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"85","height":"86","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M79.583 68.222L71.76 21.716v-5.072c0-4.38-3.566-7.945-7.945-7.945H21.44c-4.38 0-7.946 3.569-7.946 7.949v5.068l-7.812 46.47a7.923 7.923 0 001.715 6.512 7.923 7.923 0 006.101 2.853h17.513a7.98 7.98 0 007.439-5.157l4.178-11.14 4.178 11.136a7.976 7.976 0 007.439 5.158H71.76a7.923 7.923 0 006.101-2.854 7.897 7.897 0 001.722-6.478v.006zM18.792 16.648a2.65 2.65 0 012.648-2.649h42.375a2.647 2.647 0 012.649 2.645v2.649H18.792v-2.645zm55.004 54.66c-.298.354-.957.95-2.036.95H54.244a2.662 2.662 0 01-2.48-1.718l-6.657-17.751a2.651 2.651 0 00-4.966 0l-6.658 17.75a2.66 2.66 0 01-2.48 1.716l-17.505.003a2.624 2.624 0 01-2.036-.95 2.643 2.643 0 01-.563-2.205l7.482-44.51h15.275L29.524 36.99a2.646 2.646 0 001.675 3.35 2.644 2.644 0 003.347-1.672l4.691-14.073h6.784l4.69 14.073a2.647 2.647 0 002.51 1.811c.275 0 .56-.046.838-.14a2.652 2.652 0 001.675-3.35L51.599 24.59h15.275l7.495 44.546a2.607 2.607 0 01-.573 2.168v.005z","fill":"#fff"}})])
          )
        }
      }
    